import { ActionTypes } from "@/App/constants/actionTypes";
import { PricingLevelsTypes, GeneralTypes } from "@/types";

type PricingLevelsListAction = {
  type: typeof ActionTypes.LIST_PRICING_LEVELS;
  payload: GeneralTypes.QueryOptions;
};

export const pricingLevelsList = (data: { data: GeneralTypes.QueryOptions }): PricingLevelsListAction => {
  return {
    type: ActionTypes.LIST_PRICING_LEVELS,
    payload: data.data,
  };
};

type PricingLevelsListResultsAction = {
  type: typeof ActionTypes.LIST_PRICING_LEVELS_RESULTS;
  payload: PricingLevelsTypes.PricingLevelAPIResponse;
};

export const pricingLevelsListResults = (
  data: PricingLevelsTypes.PricingLevelAPIResponse,
): PricingLevelsListResultsAction => {
  return {
    type: ActionTypes.LIST_PRICING_LEVELS_RESULTS,
    payload: data,
  };
};

export type ListPricingLevelsActions = PricingLevelsListAction | PricingLevelsListResultsAction;
